export default "__VITE_ASSET__G2d1uiHy__"